import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { XamaLogo } from '../../assets/svgs/icons'
import LanguageSwitcher from '../../components/languageSwitcher'
import styles from './styles.module.css'
import { useAuth } from '../../hooks/useAuth'
import PlansSelectionView from '../../components/PlansSelectionView'

function Pricing() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { userData } = useAuth()

  // Usuários logados não têm acesso a esta tela
  useEffect(() => {
    if (userData) {
      navigate('/')
    }
  }, [userData, navigate])

  if (userData) return null

  const returnUrl = `${window.location.origin}/PricingSuccess`

  return (
    <motion.div
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={styles.page}
    >
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div
            className={styles.logoContainer}
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            <XamaLogo width={110} height={30} />
          </div>

          <nav className={styles.nav}>
            <button
              className={styles.navLink}
              onClick={() => navigate('/SignIn')}
            >
              {t('pricing.nav_login')}
            </button>
          </nav>

          <div className={styles.headerActions}>
            <button
              className={styles.buttonCadastrar}
              onClick={() => navigate('/Register')}
            >
              {t('pricing.nav_register')}
            </button>
            <div className={styles.languageSwitcherContainer}>
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>

      <PlansSelectionView
        showBackButton={false}
        showCancelAccount={false}
        returnUrl={returnUrl}
        isGuest={true}
      />

      <div className={styles.footer}>
        <div className={styles.main}>
          <p className={styles.footerText}>
            {t('pricing.footer_text')} &nbsp;
            <a
              href="https://xama.ai/termos-de-uso"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
            >
              {t('pricing.footer_terms')}
            </a>
            &nbsp;{t('pricing.footer_and')} &nbsp;
            <a
              href="https://xama.ai/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
            >
              {t('pricing.footer_privacy')}
            </a>
          </p>
        </div>
      </div>
    </motion.div>
  )
}

export default Pricing
